import type { ShortcutRow } from "./ShortcutsDialog.types";

/** Two rows that read as one: "Undo" and "Redo" become "Undo / Redo", keys side by side. */
export interface ShortcutPair {
  /** The two row ids, in the order they read. */
  ids: readonly [string, string];
  /** Label of the merged row, e.g. "Move / Resize". */
  label: string;
  /** Show only the chords of this key from each row (one arrow of four). */
  onlyKey?: string;
}

const pick = (row: ShortcutRow, onlyKey?: string) =>
  onlyKey ? row.chords.filter((chord) => chord.key === onlyKey) : row.chords;

/**
 * Folds each pair into one row with `thenChords`, placed where its first row was. A pair whose
 * rows are not both present is left as it is.
 */
export const mergeShortcutPairs = (
  rows: readonly ShortcutRow[],
  pairs: readonly ShortcutPair[],
): ShortcutRow[] => {
  const out = [...rows];
  pairs.forEach(({ ids, label, onlyKey }) => {
    const first = out.find((row) => row.id === ids[0]);
    const second = out.find((row) => row.id === ids[1]);
    if (!first || !second) return;
    const merged: ShortcutRow = {
      id: `${first.id}+${second.id}`,
      label,
      chords: pick(first, onlyKey),
      thenChords: pick(second, onlyKey),
      soon: first.soon && second.soon,
    };
    out.splice(out.indexOf(first), 1, merged);
    out.splice(out.indexOf(second), 1);
  });
  return out;
};
